import { QueryClient } from '@tanstack/react-query';
import { isRateLimited } from 'core/api/rateLimit';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        const status = (error as { status?: number })?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        if (status === 429 || isRateLimited()) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
  },
});
